import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteIdData,
  getDataWithStudent,
  updateData,
} from "../../../lib/studentprogresstask";
import { useAuth } from "../../../usercontext";
import DataTable from "react-data-table-component";
import moment from "moment";

export default function GlobalStudentTask({
  studentId,
  type,
  isStudent,
}) {
  
  const [studentProgressTasks, setStudentProgressTasks] = useState([]);
  const [showHiddenTasks, setShowHiddenTasks] = useState(sessionStorage.getItem("hiddenTasks") === "true" || false);
  const [searchText, setSearchText] = useState("");

console.log('isStudent', isStudent);


  const filteredTasks = studentProgressTasks
		.filter((task) => showHiddenTasks || !task.ishide)
		.filter((task) => {
			const name = task.taskname?.toLowerCase() || ''
			const subject = task.subject?.toLowerCase() || ''
			return name.includes(searchText.toLowerCase()) || subject.includes(searchText.toLowerCase())
		})
		.sort((a, b) => {
			// Sort by ishide status first (false comes before true)
			if (a.ishide !== b.ishide) {
				return a.ishide ? 1 : -1
			}
			// If ishide status is the same, sort by taskname
			return (a.taskname || '').localeCompare(b.taskname || '')
		})

	console.log('*-*-*-* filteredTasks', filteredTasks)

  const { profile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  console.log("profile?.role", profile?.role);
  isStudent = profile?.role === "Instructor" ? false : true;

  const queryParams = new URLSearchParams(location.search);
const collapseParam = queryParams.get("collapse");
//const [isCollapseOpen, setIsCollapseOpen] = useState(collapseParam === "open");
const [isCollapseOpen, setIsCollapseOpen] = useState("open");

const toggleCollapse = () => {
  const newValue = !isCollapseOpen;
  const params = new URLSearchParams(location.search);
  if (newValue) {
    params.set("collapse", "open");
  } else {
    params.delete("collapse");
  }
  setIsCollapseOpen(newValue);
  navigate(`${location.pathname}?${params.toString()}`, { replace: true });
};

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure?")) {
      await deleteIdData(id);
      getStudentProgressTasks();
    }
  };

  const handleCheckboxStudentTask = async (progressTaskId, currentValue) => {
    const newValue = !currentValue;
    await updateData(progressTaskId, { isFinish: newValue, ishide: newValue });
    getStudentProgressTasks();
  };

  const getStudentProgressTasks = async () => {
    const stasks = await getDataWithStudent(studentId, type);
    setStudentProgressTasks(stasks);
  };

  useEffect(() => {
    getStudentProgressTasks();
  }, []);

  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
    cells: {
      style: {
        fontSize: "15px",
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
    rows: {
      style: {
        minHeight: "50px",
      },
    },
  };

  const columns = [
    {
      width: "12%",
      name: "Subject",
      selector: (row) => row.subject,
      sortable: true,
    },
    {
      id: "taskname",
      name: "Task",
      width: "60%",
      selector: (row) => row.taskname,
      sortable: true,
    },
    {
      name: "Assigned",
      width: "8%",
      selector: (row) => moment(row.taskdate).format('MMM DD'),
      sortable: true,
    },
    {
      name: "Due",
      width: "5%",
      selector: (row) => moment(row.taskenddate).format('MMM DD'),
      sortable: true,
    },
    {
      name: "Done",
      width: "5%",
      cell: (row) => (
        <input
          type="checkbox"
          checked={row.isFinish}
          onChange={() => handleCheckboxStudentTask(row.id, row.isFinish)}
          // disabled={isStudent}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    !isStudent && {
      name: "Actions",
      width: "10%",
      cell: (row) => (
        <div className="d-flex justify-content-center gap-2">
        <button
          className="btn btn-warning btn-sm"
          style={{ minWidth: "40px", padding: "6px 12px" }}
          onClick={() =>
            navigate(
              `/instructor/instructor-studenttaskedit/${row.id}?studentId=${studentId}&type=${type}`
            )
          }
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </button>
        <button
          className="btn btn-danger btn-sm"
          style={{ minWidth: "40px", padding: "6px 12px" }}
          onClick={() => handleDelete(row.id)}
        >
           <i className="fa-solid fa-trash"></i>
        </button>
      </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ].filter(Boolean);

  return (
		<div className="settings-widget">
			<div className="settings-inner-blk p-0">
				<div className="d-flex p-2 justify-content-between align-items-center">
					<h4 className="px-3">
						Task{' '}
						<button
							type="button"
							className="btn btn-outline-info"
							// onClick={() => setIsCollapseOpen((prev) => !prev)}
							onClick={toggleCollapse}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="15"
								height="15"
								fill="currentColor"
								className="bi bi-chevron-double-down"
								viewBox="0 0 16 16"
							>
								<path
									fillRule="evenodd"
									d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
								/>
								<path
									fillRule="evenodd"
									d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
								/>
							</svg>
						</button>
					</h4>

					<div className="d-flex align-items-center gap-2">
						{isCollapseOpen && (
							<div className="mx-3 text-end">
								<button
									onClick={() => setShowHiddenTasks((prev) => {sessionStorage.setItem("hiddenTasks", !prev); return !prev})}
									className="btn btn-outline-light"
									style={{
										background: showHiddenTasks ? '#392C7D' : '#6C5DD3',
										borderColor: showHiddenTasks ? '#392C7D' : '#6C5DD3',
										color: '#fff'
									}}
								>
									{showHiddenTasks ? 'Hide Done Tasks' : 'Show Hidden Tasks'}
								</button>
							</div>
						)}
						{isCollapseOpen && (
							<div className="p-3">
								<input
									type="text"
									className="form-control"
									placeholder="Search tasks..."
									value={searchText}
									onChange={(e) => setSearchText(e.target.value)}
								/>
							</div>
						)}
						{!isStudent && (
							<div className="mx-3 text-end">
								<button
									className="btn btn-primary"
									onClick={() => navigate(`/instructor/instructor-studenttaskedit/Add?studentId=${studentId}&type=${type}&collapse=open`)}
								>
									Add New Task
								</button>
							</div>
						)}
					</div>
				</div>

				{isCollapseOpen && (
					<div className="p-2" style={{ overflowX: 'auto' }}>
						<DataTable
							columns={columns}
							data={filteredTasks}
							pagination
							highlightOnHover
							responsive
							dense
							noDataComponent="No tasks found."
							customStyles={customStyles}
							defaultSortFieldId="ishide"
							defaultSortAsc={true}
						/>
					</div>
				)}
			</div>
		</div>
	)
}
